module.exports = __webpack_public_path__ + "img/water_100.d343979c.gif";